import { AttachmentCard } from '@/components/ui/AttachmentCard/AttachmentCard';
import type { TeleportContextValue } from '@/hooks/useTeleportToTarget';
import { ProjectChatCard } from '@/features/newdesign/projects/chat/ProjectChatCard';
import type {
  ChatAttachedProjectPayload,
  ChatAttachedSessionPayload,
} from '@/components/Messenger/types/chatMessageTypes';

export interface MessengerComposerContextAttachBadgesProps {
  attachedProjects: ChatAttachedProjectPayload[];
  attachedSessions: ChatAttachedSessionPayload[];
  onRemoveProject: (projectId: string) => void;
  onRemoveSession: (sessionId: string) => void;
  teleport: TeleportContextValue | null;
}

export function MessengerComposerContextAttachBadges({
  attachedProjects,
  attachedSessions,
  onRemoveProject,
  onRemoveSession,
  teleport,
}: MessengerComposerContextAttachBadgesProps) {
  return (
    <div className="chatAssistant__attachBadgesRow">
      {attachedProjects.map((p) => (
        <ProjectChatCard
          key={`p-${p.id}`}
          projectId={p.id}
          name={p.name || p.id}
          onOpen={(id) => teleport?.goToProject(id)}
          onRemove={() => onRemoveProject(p.id)}
        />
      ))}
      {attachedSessions.map((s) => (
        <AttachmentCard
          key={`s-${s.id}`}
          variant="session"
          title={s.label || s.date || s.id}
          subtitle="Сессия"
          onClick={() => teleport && s.date && teleport.goToSession({ id: s.id, date: s.date })}
          onRemove={() => onRemoveSession(s.id)}
          removeButtonClassName="chatAssistant__close"
        />
      ))}
    </div>
  );
}
